import {AutoPlayButtonModule} from '@fantasmagames/slot/src/modules/keypad/autoplay/AutoPlayButtonModule';
import {FreeRoundsScreenEvents} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenEvents';

export class RecodeAutoPlayButtonModule extends AutoPlayButtonModule {
	protected _isWaitingForFreeGames: boolean = false;

	protected _isFreeRoundScreenOn: boolean = false;

	protected setupEvents(): void {
		super.setupEvents();
		this.on(FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_HIDDEN, this.onFreeGamesScreenClosed);
		this.on(FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_SHOWN, this.onFreeGamesScreenOpened);
		this.on(FreeRoundsScreenEvents.EXPECTED_TO_SHOW_FREE_ROUNDS_WINDOW, this.onExpectedToShowFreeRounds);
	}

	protected onFreeGamesScreenClosed(): void {
		this._isFreeRoundScreenOn = false;

		if (this._isWaitingForFreeGames) {
			this._isWaitingForFreeGames = false;
			this.onCanSpin();
		}
	}

	protected onFreeGamesScreenOpened(): void {
		this._isFreeRoundScreenOn = true;
	}

	protected onCanSpin(): void {
		if (!this._isWaitingForFreeGames) {
			super.onCanSpin();
		}
	}

	protected onExpectedToShowFreeRounds(): void {
		this._isWaitingForFreeGames = true;

		this.view.disableAutoplayButton();
	}
}


// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/autoplay/recode/RecodeAutoPlayButtonModule.ts